import { Text } from '@/components/ui';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Notification } from './components/Notification';
import { useNotifications } from '@/hooks/useNotifications';
import { Loader } from '@/components/Loader';

export function NotificationsPage() {
  const { t } = useTranslation();
  const { notifications, isLoading, markingAsReadIds, markAsRead, markAllAsRead } =
    useNotifications();

  useEffect(() => {
    const unreadNotifications = notifications.filter((n) => !n.isRead);
    if (unreadNotifications.length > 0) {
      markAllAsRead();
    }
  }, [notifications, markAllAsRead]);

  return (
    <div className="gap-2xl flex flex-1 flex-col">
      <Loader isLoading={isLoading} />
      <header className="flex w-full items-center justify-between">
        <Text as="h1" variant="heading">
          {t('notifications.title')}
        </Text>
      </header>

      <section className="gap-md flex flex-col">
        {notifications.length === 0 ? (
          <Text className="text-neutral-muted py-8 text-center">{t('notifications.empty')}</Text>
        ) : (
          notifications.map((notification) => (
            <Notification
              key={notification.id}
              notification={notification}
              onMarkAsRead={markAsRead}
              isMarkingAsRead={markingAsReadIds.has(notification.id)}
            />
          ))
        )}
      </section>
    </div>
  );
}
